import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Maintenance } from '../../interfaces/Maintenance';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService 
{
  private readonly HOST:string  = environment.BASE_URL

  constructor(
    private httpClient: HttpClient
  ) { }

  getData():Observable<Maintenance[]>
  {
    const url = `${this.HOST}/maintenance`

    return this.httpClient.get<Maintenance[]>(url)
  }
}
